import React, {Component} from 'react';
import {connect} from 'react-redux';
import {createLoadingSelector} from '../../../../selectors';
import {Form, Formik} from "formik";
import isEmpty, {generateId} from "../../../../utils/helpers";
import {createOrderChangeDevice} from "../../../../actions/dashboardActions/orders.actions";

class RemoveEquipment extends Component {

    handleDeviceSelectChange = (formProps, selectedDevice) => {
        let device = formProps.values.devices.find((d) => d.id === selectedDevice.id);
        const devices = formProps.values.devices;

        if (!isEmpty(device)) {
            formProps.setFieldValue("devices", devices.filter(d => d.id !== device.id));
            return;
        }

        const numbers = {};
        selectedDevice.apiServiceDeviceNums.forEach(num => {
            numbers[num.typeId] = num.number;
        });

        device = {
            id: selectedDevice.id,
            deviceGroupId: selectedDevice.deviceGroupId,
            deviceProfileId: selectedDevice.deviceProfileId,
            itemId: selectedDevice.deviceItemId,
            action: 'REMOVE',
            numbers: numbers
        };

        formProps.setFieldValue("devices", [device]);
    }

    renderDeviceSelect = (formProps, device) => {
        return (
            <>
                <div className="form-group">
                    <span className="h-check">
                        <label>{device.deviceItemDescription || 'Custom'} - {device.deviceProfile}&nbsp;</label>
                        <div className="form-check checkbox-slider checkbox-slider--b-flat">
                            <label>
                                <input
                                    type="checkbox"
                                    name={`device_select`}
                                    checked={!isEmpty(formProps.values.devices.find(d => d.id === device.id))}
                                    onChange={(event) => this.handleDeviceSelectChange(formProps, device)}
                                />
                                <span>&nbsp;</span>
                            </label>
                        </div>
                    </span>
                </div>

                <fieldset>

                    <legend>Device Numbers</legend>

                    {device.apiServiceDeviceNums.map(number => (
                        <p className="row">
                            <div className="col-sm-6"><b>{number.type}</b></div>
                            <div className="col-sm-6">{number.number}</div>
                        </p>
                    ))}

                </fieldset>

                {/*{errors.deviceGroupId &&*/}
                {/*<div className="invalid-feedback">{errors.deviceGroupId}</div>*/}
                {/*}*/}

            </>
        );
    }

    handleOnSubmit = (values, actions) => {
        this.handleNext({...values});
    }

    createValuesBundle = (values) => ({removedDevices: values.devices})

    handleNext = (values) => {
        const { next } = this.props;
        if (!next) {
            return;
        }

        next({
            values: this.createValuesBundle(values),
            formValues: values
        });
    }

    isSubmitting = () => {
        return this.props.orderCreationLoader === true;
    }

    render() {
        const { stepFormValues } = this.props;

        const {
            wizardData,
        } = this.props;

        return (
            <>
                <Formik
                    onSubmit={this.handleOnSubmit}
                    initialValues={isEmpty(stepFormValues)? {
                        devices: []
                    } : stepFormValues}
                    render={(formProps) => (
                      <Form onSubmit={formProps.handleSubmit} className="cmv-form" autoComplete="off">

                          <div className="tab-content wizard-content mh-70 overflow-scroll mx-4">

                              {wizardData.serviceDevices.map(device =>
                                this.renderDeviceSelect(formProps, device)
                              )}

                          </div>

                              <div className="wizard-footer d-flex justify-content-between px-5">
                                  <button
                                    type="submit"
                                    className="btn btn-primary btn-next-tab ml-auto"
                                    onClick={formProps.handleSubmit}
                                    disabled={this.isSubmitting() || isEmpty(formProps.values.devices)}
                                  >
                                      CONTINUE
                                  </button>
                              </div>



                      </Form>
                        )}
                    />
                </>
                )
                }
}


const mapStateToProps = (state) => {
    return {
    }
};

const mapDispatchToProps = {
    createOrderChangeDevice,
};

export default connect(mapStateToProps, mapDispatchToProps)(RemoveEquipment);
